module.exports = __webpack_public_path__ + "static/student_accom-929f11ad393b2c705cd8d43196a57014.png";